import { render } from "./WysiwygEditorAdvanced.vue?vue&type=template&id=6607e88e"
import script from "./WysiwygEditorAdvanced.vue?vue&type=script&lang=js"
export * from "./WysiwygEditorAdvanced.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/components/WysiwygEditorAdvanced.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6607e88e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6607e88e', __exports__)) {
    api.reload('6607e88e', __exports__)
  }
  
  module.hot.accept("./WysiwygEditorAdvanced.vue?vue&type=template&id=6607e88e", () => {
    api.rerender('6607e88e', render)
  })

}


export default __exports__